export default "/images/2b25dc7b4568f2b753bcff49186f9fd6.avif";